import {
    FETCH_GOLF_COURSE_STATS,
    FETCH_GOLF_COURSE_STATS_SUCCESS,
    FETCH_GOLF_COURSE_STATS_FAIL
} from 'actions/golfCourseActions.js';

import { getGolfCourseStoreId } from 'utils/golf/GolfCourseStatsUtil';

// Used for updates/saves
export const NETWORKING_STATUSES = {
    FAIL: 'FAIL',
    SUCCESS: 'SUCCESS',
    FETCHING: 'FETCHING'
};

const INITIAL_STATE = {
    golfCourses: {},
    networkingStatus: NETWORKING_STATUSES.SUCCESS,
    courseStatsNetworkStatus: {}
};

const fetchGolfCourseStatsSuccess = (state, action) => {
    let idValue = getGolfCourseStoreId(
        action.golfCourseStats.courseSnapshotId || action.courseSnapshotId,
        action.golfCourseStats.courseGlobalId || action.courseGlobalId,
        action.fromDate
    );

    return {
        golfCourses: {
            ...state.golfCourses,
            ...(idValue && { [idValue]: action.golfCourseStats })
        },
        networkingStatus: NETWORKING_STATUSES.SUCCESS,
        courseStatsNetworkStatus: {
            ...state.courseStatsNetworkStatus,
            ...(idValue && { [idValue]: NETWORKING_STATUSES.SUCCESS })
        }
    };
};

const fetchGolfCourseStatsStart = (state, action) => {
    let idValue = getGolfCourseStoreId(action.courseSnapshotId, action.courseGlobalId, action.fromDate);
    return {
        golfCourses: {
            ...state.golfCourses
        },
        networkingStatus: NETWORKING_STATUSES.FETCHING,
        courseStatsNetworkStatus: {
            ...state.courseStatsNetworkStatus,
            ...(idValue && { [idValue]: NETWORKING_STATUSES.FETCHING })
        }
    };
};

const fetchGolfCourseStatsFail = (state, action) => {
    return state;
};

const handlers = {
    [FETCH_GOLF_COURSE_STATS_SUCCESS]: fetchGolfCourseStatsSuccess,
    [FETCH_GOLF_COURSE_STATS]: fetchGolfCourseStatsStart,
    [FETCH_GOLF_COURSE_STATS_FAIL]: fetchGolfCourseStatsFail
};

export default function golfCourseStats(state = INITIAL_STATE, action = {}) {
    const handler = handlers[action.type];

    if (!handler) return state;
    return handler(state, action);
}

// Actions
export function fetchGolfCourseStats(
    courseSnapshotId,
    courseGlobalId,
    backNineCourseGlobalId,
    fromDate,
    userLocale,
    evictCache
) {
    return {
        type: FETCH_GOLF_COURSE_STATS,
        courseSnapshotId: courseSnapshotId,
        courseGlobalId: courseGlobalId,
        backNineCourseGlobalId: backNineCourseGlobalId,
        fromDate: fromDate,
        userLocale: userLocale,
        meta: {
            cacheTime: evictCache ? null : 60000
        }
    };
}

// Getters
export const getGolfCourseStats = (state, courseSnapshotId, fromDate, courseGlobalId) => {
    const idValue = getGolfCourseStoreId(courseSnapshotId, courseGlobalId, fromDate);
    return state.golfCourseStats.golfCourses[idValue] || undefined;
};

export const getGolfCourseStatsNetworkStatus = (state) => {
    return state.golfCourseStats.networkingStatus;
};

export const getGolfCourseStatNetworkStatus = (state, courseSnapshotId, fromDate, courseGlobalId) => {
    const idValue = getGolfCourseStoreId(courseSnapshotId, courseGlobalId, fromDate);
    return state.golfCourseStats.courseStatsNetworkStatus[idValue] || state.golfCourseStats.networkingStatus;
};
